import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  ThemeProvider,
  createTheme
} from '@mui/material';

// Create a light theme with consistent colors
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#222222'
    },
    text: {
      primary: '#222222',
      secondary: '#666666'
    }
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  }
});

const BoxCountDialog = ({ open, onClose, onConfirm, orderDetails }) => {
  const [boxCount, setBoxCount] = useState(1);

  const handleConfirm = () => {
    const count = parseInt(boxCount, 10);
    if (count > 0) {
      onConfirm(count);
    }
  };

  // Calculate total pieces for reference
  const totalPieces = orderDetails?.lines?.reduce((sum, line) => 
    sum + Object.values(line.sizes || {}).reduce((total, size) => total + (parseInt(size) || 0), 0), 0
  ) || 0;

  return (
    <ThemeProvider theme={theme}>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'white',
            color: '#222222'
          }
        }}
      >
        <DialogTitle style={{ color: '#222222' }}>Print Box Labels</DialogTitle>
        <DialogContent>
          <Box mb={2}>
            <Typography variant="body1" style={{ color: '#222222' }} gutterBottom>
              Invoice: #{orderDetails?.orderNumber}
              <br />
              Client: {orderDetails?.client}
            </Typography>
            <Typography variant="body2" style={{ color: '#666666' }} gutterBottom>
              Total Pieces: {totalPieces}
            </Typography>
          </Box>

          <Typography variant="body2" style={{ color: '#666666' }} gutterBottom>
            How many boxes will you need for these items?
            <br />
            This will generate labels numbered "Box 1 of X" through "Box X of X".
          </Typography>

          <TextField
            autoFocus
            margin="dense"
            label="Number of Boxes Needed"
            type="number"
            fullWidth
            value={boxCount}
            onChange={(e) => setBoxCount(e.target.value)}
            inputProps={{ min: 1 }}
            helperText="Based on garment type and quantity"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} style={{ color: '#666666' }}>
            Cancel
          </Button>
          <Button 
            onClick={handleConfirm} 
            variant="contained"
            style={{
              backgroundColor: '#222222',
              color: 'white'
            }}
          >
            Print {boxCount} Box Label{boxCount > 1 ? 's' : ''}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default BoxCountDialog; 